import { render, staticRenderFns } from "./defaultForm.vue?vue&type=template&id=6f03eb82&scoped=true&"
import script from "./defaultForm.vue?vue&type=script&lang=ts&"
export * from "./defaultForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f03eb82",
  null
  
)

export default component.exports